import { getFacultyCurrentCourses } from "../../services/faculty/v1/faculty";
import { GET_CURRENTCOURSES } from "./actionTypes";

export const getCurrentCourses = (irn) => async (dispatch, getState) => {
  const state = getState();
  
  // Check if user is authenticated before making API call
  if (!state.demographics.issuerId) {
    return;
  }
  
  await getFacultyCurrentCourses(irn)
    .then((response) => {
      dispatch({ type: GET_CURRENTCOURSES, payload: response.data });
    })

    .catch((error) => {
      dispatch({
        type: GET_CURRENTCOURSES,
        payload: error.request,
      });
    });
};